import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { NotificationConnectionVariantEnum } from "./enums";
import { PropType, ref } from "vue";
import {
  NotificationConnected,
  NotificationDisconnected,
  NotificationReconnected,
} from "./components";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'notification-сonnection',
  props: {
  variant: { type: String as PropType<NotificationConnectionVariantEnum> },
},
  emits: ["closeNotification", "reconnect"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Получение компонента в зависимости от состояния соединения */
const getConnectionComponent = () => {
  switch (props.variant) {
    case NotificationConnectionVariantEnum.Disconnected:
      return NotificationDisconnected;
    case NotificationConnectionVariantEnum.Connected:
      return NotificationConnected;
    case NotificationConnectionVariantEnum.Reconnected:
      return NotificationReconnected;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(getConnectionComponent()), {
    onCloseNotification: _cache[0] || (_cache[0] = ($event: any) => (emit('closeNotification'))),
    onReconnect: _cache[1] || (_cache[1] = ($event: any) => (emit('reconnect')))
  }, null, 32))
}
}

})